import * as React from 'react';
import { FullScreenLoadingSpinner } from '@/components/full-screen-loading-spinner';
import { createRouter } from '@/config/router';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './config/queryClient';
import { useGtmScript } from './hooks/use-gtm-script';

export const router = createRouter();
const LazyChatWidgetSwitch = React.lazy(
  () => import('./components/chatBot/components/chatWidgetSwitch')
);
function App() {
  return <RouterProvider router={router} />;
}

export default function UserApp() {
  const [showChatbot, setShowChatbot] = React.useState(false);
  useGtmScript();
  React.useEffect(() => {
    // Delay chatbot until after main content is loaded - 4 seconds
    const timer = setTimeout(() => {
      setShowChatbot(true);
      console.warn('Chatbot is ready');
    }, 4000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <React.Suspense fallback={<FullScreenLoadingSpinner />}>
      <QueryClientProvider client={queryClient}>
        <App />
        {showChatbot && (
          <React.Suspense fallback={null}>
            <LazyChatWidgetSwitch />
          </React.Suspense>
        )}
      </QueryClientProvider>
    </React.Suspense>
  );
}
